import {
    EventBus
} from "@/eventBus";
import {
    mapMutations
} from 'vuex';
import playOperatorSoundMixin from "@/mixins/playOperatorSound";

export default {
    mixins: [playOperatorSoundMixin],
    data() {
        return {
            idlePhoneTimeout: 180000,
            idlePhone: null,
            showCheckoutOperatorModal: false,
            checkerEvents: [
                "mousedown",
                "mousemove",
                "keypress",
                "scroll",
                "touchstart"
            ]
        }
    },
    methods: {
        ...mapMutations([
            "RESET_PRODUCTS_AND_SETS_FORM",
            "RESET_ORDER_DATA",
            "SET_REFETCH_ORDER_DATA",
            "SET_IS_LOADING_ORDER_DATA",
            "SET_SHOW_ORDER_FORM_DATA",
            "RESET_REQUEST_FORM",
        ]),
        activateOperatorCheckout() {
            this.idlePhone = setTimeout(this.logoutTimeOut, this.idlePhoneTimeout);
            this.checkerEvents.forEach(name => {
                document.addEventListener(name, this.resetTimer, true);
            });
        },
        logoutTimeOut() {
            this.showCheckoutOperatorModal = true;
        },
        resetTimer() {
            clearTimeout(this.idlePhone);
            this.idlePhone = setTimeout(this.logoutTimeOut, this.idlePhoneTimeout);
        },
        onModalConfirm(val) {
            this.showCheckoutOperatorModal = false;
            if (val) {
                this.resetTimer();
            } else {
                EventBus.$emit("operator-checkout-failed", true);
                this.resetOrder();
                this.$router.push({
                    name: "order"
                });
            }
        },
        resetOrder() {
            this.RESET_PRODUCTS_AND_SETS_FORM();
            this.RESET_REQUEST_FORM();
            this.RESET_ORDER_DATA();
            this.SET_SHOW_ORDER_FORM_DATA(false);
            console.log('resetOrder',false)
            this.SET_IS_LOADING_ORDER_DATA(false);
            this.SET_REFETCH_ORDER_DATA(false);
        },
    },
    watch: {
        showCheckoutOperatorModal: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.playOperatorSound();
                    EventBus.$emit("show-phone", false);
                }
            }
        },
    },
    mounted() {
        this.activateOperatorCheckout();
    },
    beforeDestroy() {
        clearTimeout(this.idlePhone);
        this.checkerEvents.forEach(name => {
            document.removeEventListener(name, this.resetTimer, true);
        });
    }
}